<button
  mat-button
  (click)="navigationClicked.emit()"
  [intercomTarget]="'01-sub-navigation-48726'"
  *ngIf="!isBig"
  class="sub-design-wrapper truncate"
>
  <fa-icon [icon]="['fal', navigationType.logo]" [ngStyle]="{ color: navigationType.color }"></fa-icon>
  &nbsp;{{ navigationType.title }}
</button>
<div *ngIf="isBig" class="sub-design-title">
  <fa-icon [icon]="['fal', navigationType.logo]" [ngStyle]="{ color: navigationType.color }"></fa-icon>
  &nbsp;{{ navigationType.title }}
</div>
